export const TaxZonesTableColumns = [
    {
        id: "name",
        labelEn: "Name",
        labelAr: "الاسم",
        align: "left",
        sortable: true,
    },
    {
        id: "rates_count",
        labelEn: "Rates",
        labelAr: "النسب",
        align: "center",
        sortable: false,
    },
    {
        id: "is_active",
        labelEn: "Active",
        labelAr: "نشط",
        align: "center",
        sortable: false,
    },
];
